// extracted by mini-css-extract-plugin
module.exports = {"container":"_e8942daf","wrapper":"_836c83fb","ratingWrapper":"_9cb4c63c","goldDiamond":"_19ec808c","platinumDiamond":"_ae9c489a","icon":"_30bc04e3"};